module.exports = __webpack_public_path__ + "dist/img/logo-small.d8021b13.png";